var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchReportIcon = function SvgSearchReportIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7778 20L11.4722 12.6944C10.9167 13.1759 10.2689 13.5509 9.52892 13.8194C8.78893 14.088 8.00152 14.2222 7.16667 14.2222C5.16367 14.2222 3.46847 13.5278 2.08108 12.1389C0.693695 10.75 0 9.07407 0 7.11111C0 5.14815 0.694444 3.47222 2.08333 2.08333C3.47222 0.694444 5.15278 0 7.125 0C9.09722 0 10.7731 0.694444 12.1528 2.08333C13.5324 3.47222 14.2222 5.14954 14.2222 7.11528C14.2222 7.9088 14.0926 8.67593 13.8333 9.41667C13.5741 10.1574 13.1852 10.8519 12.6667 11.5L20 18.7778L18.7778 20ZM7.13889 12.5556C8.64352 12.5556 9.92245 12.0231 10.9757 10.9583C12.0289 9.89352 12.5556 8.61111 12.5556 7.11111C12.5556 5.61111 12.0289 4.3287 10.9757 3.26389C9.92245 2.19907 8.64352 1.66667 7.13889 1.66667C5.61883 1.66667 4.32678 2.19907 3.26272 3.26389C2.19868 4.3287 1.66667 5.61111 1.66667 7.11111C1.66667 8.61111 2.19868 9.89352 3.26272 10.9583C4.32678 12.0231 5.61883 12.5556 7.13889 12.5556Z",
    fill: "#D2D3D7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchReportIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/searchReportIcon.8879d294.svg";
export { ForwardRef as ReactComponent };